import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 12a5 5 0 1 0 10 0a5 5 0 0 0 -10 0","key":"svg-0"}],["path",{"d":"M11 12h-3","key":"svg-1"}],["path",{"d":"M8 12l-5 -4v8l5 -4","key":"svg-2"}]]

const IconGenderThird = createReactComponent('outline', 'gender-third', 'GenderThird', __iconNode);

export default IconGenderThird;